import * as React from 'react';
import { Outlet } from 'react-router-dom';

import SharedLayout from './SharedLayout';
import Navigator from '../components/navigator';

export default function HeaderNavBase() {
	const [mobileOpen, setMobileOpen] = React.useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	// Pass the Navigator as a prop to SharedLayout
	const navigatorElement = (
		<Navigator mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />
	);

	return (
		<SharedLayout
			showNavigator={true}
			navigator={navigatorElement}
			headerProps={{
				title: 'Online Battery Validation Manager',
				drawerIcon: true,
				onDrawerToggle: handleDrawerToggle,
			}}
		>
			<Outlet />
		</SharedLayout>
	);
}
